/*!
 * history.nette.ajax.js v2.0.0
 * Source: https://github.com/vojtech-dobes/history.nette.ajax.js/tree/2.0.0
 * License: MIT
 */
(function($, undefined) {

// Is History API reliably supported? (based on Modernizr & PJAX)
if (!(window.history && history.pushState && window.history.replaceState && !navigator.userAgent.match(/((iPod|iPhone|iPad).+\bOS\s+[1-4]|WebApps\/.+CFNetwork)/))) return;

$.nette.ext('redirect', false);

var findSnippets = function () {
	var result = [];
	$('[id^="snippet-"]').each(function () {
		var $el = $(this);
		if (!$el.is('[data-history-nocache]')) {
			result.push({
				id: $el.attr('id'),
				html: $el.html()
			});
		}
	});
	return result;
};
var handleState = function (context, name, args) {
	var handler = context['handle' + name.substring(0, 1).toUpperCase() + name.substring(1)];
	if (handler) {
		handler.apply(context, args);
	}
};

$.nette.ext('history', {
	init: function () {
		var snippetsExt;
		if (this.cache && (snippetsExt = $.nette.ext('snippets'))) {
			this.handleUI = function (domCache) {
				var snippets = {};
				$.each(domCache, function () {
					snippets[this.id] = this.html;
				});
				snippetsExt.updateSnippets(snippets, true);
				$.nette.load();
			};
		}

		this.popped = !!('state' in window.history) && !!window.history.state;
		var initialUrl = window.location.href;

		$(window).on('popstate.nette', $.proxy(function (e) {
			var state = e.originalEvent.state || this.initialState;
			var initialPop = (!this.popped && initialUrl === state.href);
			this.popped = true;
			if (initialPop) {
				return;
			}
			if (this.cache && state.ui) {
				handleState(this, 'UI', [state.ui]);
				handleState(this, 'title', [state.title]);
			} else {
				$.nette.ajax({
					url: state.href,
					off: ['history']
				});
			}
		}, this));

		history.replaceState(this.initialState = {
			nette: true,
			href: window.location.href,
			title: document.title,
			ui: this.cache ? findSnippets() : null
		}, document.title, window.location.href);
	},
	before: function (xhr, settings) {
		this.isPost = false;
		if (!settings.nette) {
			this.href = null;
		} else if (!settings.nette.form) {
			this.href = settings.nette.ui.href;
		} else {
			var form = settings.nette.form.get(0);
			var method = form.method.toLowerCase();
			this.isPost = method === 'post';
			this.href = method === 'get'
				? (form.action || window.location.href)
				: null;
		}
	},
	success: function (payload) {
		var redirect = payload.redirect || payload.url; // backwards compatibility for 'url'
		if (redirect) {
			var regexp = new RegExp('//' + window.location.host + '($|/)');
			if ((redirect.substring(0,4) === 'http') ? regexp.test(redirect) : true) {
				this.href = redirect;
				if (this.isPost) {
					// POST redirects must load flash messages from the new page.
					window.location.href = redirect;
					return;
				}
			} else {
				window.location.href = redirect;
			}
		}
		if (this.href && this.href != window.location.href) {
			history.pushState({
				nette: true,
				href: this.href,
				title: document.title,
				ui: this.cache ? findSnippets() : null
			}, document.title, this.href);
		}
		this.href = null;
		this.isPost = false;
		this.popped = true;
	}
}, {
	href: null,
	isPost: false,
	cache: true,
	popped: false,
	handleTitle: function (title) {
		document.title = title;
	}
});

})(jQuery);
